/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * @flow
 */

export const isFieldError = (fieldName: string, touched: {string: boolean}, errors: {string: string}) => {
  return touched[fieldName] && errors[fieldName] !== undefined;
};
